import React, { Component } from "react";
import { Navbar, Form, Nav } from "react-bootstrap/";
import logo from "../assets/logo/YEX.png";
import "./navbar.css";
// import YotiButton from "./yotiButton";

class NavBar extends Component {
  state = {};

  render() {
    // const appId = "4560cc8b-0326-4cfe-a9fb-6082083c223a";
    // const scenId = "2510d5da-77a7-41c5-88f7-6984da4d2064";
    // const text = "Login";
    return (
      <div className="container-fluid navHead">
        <Navbar bg="none" variant="dark" className="mr-auto">
          <Navbar.Brand href="/crypto/">
            <img src={logo} alt="" className="m-1" />
          </Navbar.Brand>
          <Nav className="mr-auto flex-md-row flex-column">
            <Nav.Link href="" className="links m-2">
              Exchange
            </Nav.Link>
            <Nav.Link href="" className="links m-2">
              Products
            </Nav.Link>
            <Nav.Link href="" className="links m-2">
              Prices
            </Nav.Link>
          </Nav>
          <Form inline>
            <Nav className="mr-auto flex-md-row flex-column">
              <Nav.Link href="/crypto/signup" className="signUp m-2">
                Sign up
              </Nav.Link>
            </Nav>
            <Nav className="mr-auto flex-md-row flex-column">
              <div id="loginYoti" />
            </Nav>
            {/* <YotiButton appId={appId} scenId={scenId} text={text} /> */}
          </Form>
        </Navbar>
      </div>
    );
  }
}

export default NavBar;
